export const PINTEREST_ENGAGEMENT_ICON_NAMES = ['icon-message', 'icon-download'];
export const PINTEREST_SAVE_ICON_NAME = 'icon-pin';
